import { render, staticRenderFns } from "./InteractiveVideo.vue?vue&type=template&id=05ec2d90&"
import script from "./InteractiveVideo.ts?vue&type=script&lang=ts&"
export * from "./InteractiveVideo.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports